import { combineReducers } from '@reduxjs/toolkit';

import awardReducer from './award-slices';
import parametersReducer from './parameter-slices';
import roundingPolicyReducer from './rounding-policy-slices';
import shareCreditReducer from './share-credit-slices';
import signatoriesReducer from './signatories-slices';
import templateReducer from './template-slices';
import tenantReducer from './tenant-slices';
import themeReducer from './themeModeSlice';
import userGroupReducer from './userGroupSlice';

const tenantReducers = combineReducers({
  parameters: parametersReducer,
  info: tenantReducer,
  userGroup: userGroupReducer,
  themeMode: themeReducer,
  template: templateReducer,
  award: awardReducer,
  shareCredit: shareCreditReducer,
  signatories: signatoriesReducer,
  roundingPolicy: roundingPolicyReducer,
});

export default tenantReducers;
